import * as XLSX from 'xlsx/dist/xlsx.extendscript';
/* generate an array of column objects */
export const make_cols = refstr => {
	let o = [], C = XLSX.utils.decode_range(refstr).e.c + 1;
	for(var i = 0; i < C; ++i) o[i] = {name:XLSX.utils.encode_col(i), key:i}
	return o;
};


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/MakeColumns.jsx